import { ApolloError, isApolloError } from "@apollo/client";

const EXTERNAL_PROVIDER_ERROR_CODE = "PICKING_ORDER_EXTERNAL_PROVIDER";

// getOrderDetails refuses an order an external provider (dm) packs: there's nothing to pick at the
// hub. Returns the provider, which is "" when picking-service didn't name one.
export function getExternalProvider(error: unknown): string | null {
  if (!(error instanceof Error) || !isApolloError(error)) return null;
  const extensions = (error as ApolloError).graphQLErrors?.[0]?.extensions;
  if (extensions?.code !== EXTERNAL_PROVIDER_ERROR_CODE) return null;
  const meta = extensions.meta as { externalProvider?: unknown } | undefined;
  return typeof meta?.externalProvider === "string" ? meta.externalProvider : "";
}
